<template>
  <div>  <a-form-model
      ref="emailTemplateForm" :model="form" :rules="rules" v-bind="layout" >
    <div class="flex">
      <span>姓名</span>
      <a-form-model-item label="" class="item">
        <a-switch v-model="form.name_status" :checked="form.name_status==1?true:false" /><span>启用</span>
      </a-form-model-item>
      <a-form-model-item label="" class="item">
        <a-switch v-model="form.name_required" :checked="form.name_required==1?true:false"  /><span>必填</span>
      </a-form-model-item>
    </div>
    <div class="flex">
      <span>手机号</span>
      <a-form-model-item label="" class="item">
        <a-switch v-model="form.mobile_status" :checked="form.mobile_status==1?true:false" /><span>启用</span>
      </a-form-model-item>
      <a-form-model-item label="" class="item">
        <a-switch v-model="form.mobile_required" :checked="form.mobile_required==1?true:false"  /><span>必填</span>
      </a-form-model-item>
    </div>
    <div class="flex">
      <span>公司名称</span>
      <a-form-model-item label="" class="item">
        <a-switch v-model="form.company_status" :checked="form.company_status==1?true:false" /><span>启用</span>
      </a-form-model-item>
      <a-form-model-item label="" class="item">
        <a-switch v-model="form.company_required" :checked="form.company_required==1?true:false" /><span>必填</span>
      </a-form-model-item>
    </div>
    <div class="flex">
      <span>QQ</span>
      <a-form-model-item label="" class="item">
        <a-switch v-model="form.qq_status" :checked="form.qq_status==1?true:false" /><span>启用</span>
      </a-form-model-item>
      <a-form-model-item label="" class="item">
        <a-switch v-model="form.qq_required" :checked="form.qq_required==1?true:false"  /><span>必填</span>
      </a-form-model-item>
    </div>
    <div class="flex">
      <span>微信</span>
      <a-form-model-item label="" class="item">
        <a-switch v-model="form.wechat_status" :checked="form.wechat_status==1?true:false"  /><span>启用</span>
      </a-form-model-item>
      <a-form-model-item label="" class="item">
        <a-switch v-model="form.wechat_required" :checked="form.wechat_required==1?true:false"  /><span>必填</span>
      </a-form-model-item>
    </div>
    <div class="flex">
      <span>行业</span>
      <a-form-model-item label="" class="item">
        <a-switch v-model="form.industry_status" :checked="form.industry_status==1?true:false"  /><span>启用</span>
      </a-form-model-item>
      <a-form-model-item label="" class="item">
        <a-switch v-model="form.industry_required" :checked="form.industry_required==1?true:false"  /><span>必填</span>
      </a-form-model-item>
    </div>
    <div class="flex">
      <span>咨询内容</span>
      <a-form-model-item label="" class="item">
        <a-switch v-model="form.content_status" :checked="form.content_status==1?true:false" /><span>启用</span>
      </a-form-model-item>
      <a-form-model-item label="" class="item">
        <a-switch v-model="form.content_required"  :checked="form.content_required==1?true:false" /><span>必填</span>
      </a-form-model-item>
    </div>
    <div class="flex ">
      <span>验证码</span>
      <a-form-model-item label="" class="item">
        <a-switch v-model="form.captcha_status" :checked="form.captcha_status==1?true:false" /><span>启用</span>
      </a-form-model-item>
      <a-form-model-item label="" class="item" v-show="false">
        <a-switch v-model="form.captcha_required" :checked="form.captcha_required==1?true:false"  /><span>启用</span>
      </a-form-model-item>
      <p class="item"></p>
    </div>
    <a-form-model-item :wrapper-col="{ span:1, offset:2 }">
      <a-button type="primary" @click="onSubmit">
        保存
      </a-button>
    </a-form-model-item>
  </a-form-model> </div>
</template>

<script>

import {submitForm} from "../../../utils/utils"
import API from "./api/index"
export default {
  name: 'index',
  data(){
      return{
        labelCol: { span: 4 },
        wrapperCol: { span: 14 },
        form: {
          name_status:1,
          name_required:1,
          mobile_status:1,
          mobile_required:1,
          company_status:1,
          company_required:0,
          qq_status:0,
          qq_required:0,
          wechat_status:0,
          wechat_required:0,
          industry_status:0,
          industry_required:0,
          content_status:0,
          content_required:0,
          captcha_status:0 ,
          captcha_required:1
        },
      }
  },
  methods:{
    getEdit(){
      API.service.EDIT_DATA( ).then(res => {
        let val = res.data.data
        this.form = val
      })
    },
    onSubmit(){
      this.$refs.emailTemplateForm.validate(valid => {
       let formData=JSON.parse(JSON.stringify(this.form) )
        for(let key  in formData){
          if(formData[key]==false){
            formData[key]=0
          }else{
            formData[key]=1
          }
        }
        submitForm( API.service.SUBMIT_ADD, formData).then(res => {
          if (res == true) {
          } else {

          }
        })
      })}
  },
  mounted() {
    this.getEdit()
  }
}
</script>
<style scoped>
.flex{width:300px}
.flex span{line-height: 40px;height: 40px;width: 90px}
.item{width: 100px}
.ant-form-item .ant-switch{margin-right: 5px}
</style>
